<template>
  <div id="home">
    <loader-text v-if="isLoading" :title="$t('loading')" />
  </div>
</template>

<script>
  import LoaderText from '@/components/loader-text';
  import LoadOnNavigate from '@/mixins/load-on-navigate';

  export default {
    name: 'LoginView',
    components: {
      LoaderText,
    },
    mixins: [
      LoadOnNavigate,
    ],
    props: {
      token: {
        type: String,
        default: '',
      },
      career: {
        type: Number,
        default: 0,
      },
      inProgress: {
        type: Boolean,
        default: false,
      },
      unlockCode: {
        type: String,
        default: '',
      },
      url: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        isLoading: true,
      };
    },
    computed: {
      model() {
        return {
          token: this.token,
        };
      },
    },
    created() {
      const { unlockCode } = this;
      this.set({ unlockCode });
    },
    methods: {
      async load() {
        this.isLoading = true;

        if (this.$helper.isPlayerDemo12) {
          this.$ajax.get('public/demo12/').then((data) => {
            this.$test.setDemo12(data);
            this.$router.push({ name: 'check' });
          });
        } else if (this.user()) {
          this.forward();
        } else {
          this.login();
        }
        this.isLoading = false;
      },
      login() {
        this.$i18n.fallbackLocale = 'fr';
        this.$ajax.login(this.model).then(() => {
          if (this.user()) {
            if(this.user().preferred_locale == undefined)
            {
              this.$helper.setLocale('FR_fr');
            }
            else{
              this.$helper.setLocale(this.user().preferred_locale);
            }
          }
          else{
            this.$helper.setLocale(this.$i18n.fallbackLocale);
          }
          this.forward();
        }).catch((error) => {
          const code = error.response.data.error === 'invalid_demo36_token' ? 'demo36' : '0001';
          this.$router.push({ name: 'error', params: { code } });
        });
      },
      async forward() {
        if (this.career === 0) {
          this.$router.push({ name: 'module', params: { token: this.token } });
        } else {
          this.$test.getBeforeTestData(this.career, this.inProgress,this.url).then((data) => {
            if (data.anotherTestInProgress) {
              this.$router.push({ name: 'error', params: { code: 'test_already_in_progress' } });
            } else {
              this.$test.setInitialData(data);
              this.$router.push({ name: 'check' });
            }
          }).catch((error) => {
            this.$router.push({ name: 'error', params: { code: error.response.data.code } });
          });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
</style>
